import { Injectable } from '@angular/core';

import { Mapper } from '../mapper/mapper';
import { BaseAPI } from './base-api';
import { Constants } from '../../common';
import { Observable, map } from 'rxjs';
import { BasicUser, Category, TeachersReport } from '../model';
import { TeachersReportFilterForm } from 'src/app/shared/interfaces';
import { DataWithPagination } from '../../interface';

@Injectable({
  providedIn: 'root',
})
export class TeachersReportApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getTeachersReport(filter: TeachersReportFilterForm): Observable<DataWithPagination<TeachersReport[]>> {
    return this.baseAPI.post(Constants.GET_TEACHERS_REPORT_API_URL, filter).pipe(
      map((res) => {
        const data: DataWithPagination<TeachersReport[]> = {
          data: this.mapper.fromListJson(TeachersReport, res.items),
          count: res.count,
        };
        return data;
      })
    );
  }
}
